export * from './src/innovation-playground-v2-message-assistant-training.context.js';
